import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Products from "./components/Products";
import Klimaanlagen from "./components/Klimaanlagen";
import Benefits from "./components/Benefits";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import CookieBanner from "./components/CookieBanner";
import GlobalChatbot from "./components/GlobalChatbot";
import ElektrikPage from "./pages/ElektrikPage";
import WaermepumpePage from "./pages/WaermepumpePage";
import KlimaanlagenPage from "./pages/KlimaanlagenPage";
import DachdeckerPage from "./pages/DachdeckerPage";
import PartnerPage from "./pages/PartnerPage";
import WallboxPage from "./pages/WallboxPage";
import BeratungPage from "./pages/BeratungPage";
import PhotovoltaikPage from "./pages/PhotovoltaikPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import IndustriePage from "./pages/IndustriePage";
import { Toaster } from "./components/ui/sonner";
import BillScanner from "./components/BillScanner";
import SolarConfigurator from "./components/SolarConfigurator";
import LiveEnergyDashboard from "./components/LiveEnergyDashboard";
import { LanguageProvider } from "./context/LanguageContext";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Products />
      <Klimaanlagen />
      <BillScanner />
      <SolarConfigurator />
      <LiveEnergyDashboard />
      <Benefits />
      <Process />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/elektrik" element={<ElektrikPage />} />
            <Route path="/waermepumpe" element={<WaermepumpePage />} />
            <Route path="/klimaanlagen" element={<KlimaanlagenPage />} />
            <Route path="/dachdecker" element={<DachdeckerPage />} />
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/wallbox" element={<WallboxPage />} />
            <Route path="/beratung" element={<BeratungPage />} />
            <Route path="/photovoltaik" element={<PhotovoltaikPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/industrie" element={<IndustriePage />} />
          </Routes>
          <CookieBanner />
          <GlobalChatbot />
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
